<template>
  <div :class="['status-wrapper', status.class]">
    {{ status.text }}
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { BULK_HISTORY_STATUS ,BULK_DEAL_STATUS } from '@/utils/enum/bulkActions';


const props = defineProps({
  type: {
    type: String,
    default: '',
  },
});

const status = computed(() => {
  switch (props.type) {
    case BULK_HISTORY_STATUS.WAITING:
      return { text: 'Sıraya Alındı', class: 'yellow' };
    case BULK_HISTORY_STATUS.PROCESSING:
      return { text: 'Hazırlanıyor', class: 'yellow' };
    case BULK_HISTORY_STATUS.FINISHED_SUCCESS:
      return { text: 'Şablon Hazır', class: 'green' };
    case BULK_HISTORY_STATUS.FINISHED_FAIL:
    case BULK_DEAL_STATUS.FAILED_TO_DOWNLOAD:
      return { text: 'İndirilemedi', class: 'red' };
    case BULK_HISTORY_STATUS.IN_QUEUE:
      return { text: 'İşleniyor', class: 'yellow' };
    case BULK_HISTORY_STATUS.PROCESSED:
      return { text: 'Yüklendi', class: 'green' };
    case BULK_HISTORY_STATUS.REJECT:
      return { text: 'Yüklenemedi', class: 'red' };
    case BULK_DEAL_STATUS.DOWNLOADED:
      return { text: 'İndirildi', class: 'green' };
    case BULK_DEAL_STATUS.WAITING_FOR_DOWNLOAD:
      return { text: 'Bekliyor', class: 'yellow' };
    default:
      return { text: '', class: '' };
  }
});
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.status-wrapper {
  padding: 5px 12px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 4px;
  width: max-content;
  border: 0.5px solid $colorD30;

  &.disabled {
    cursor: default;
    opacity: 0.6;
  }

  &::before {
    content: "";
    display: block;
    width: 16px;
    height: 16px;
    background-repeat: no-repeat;
  }

  &.green {
    background: $colorS05;
    color: $colorS50;

    &::before {
      width: 12px;
      height: 12px;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12' fill='none'%3E%3Ccircle cx='6' cy='6' r='6' fill='%23008C20'/%3E%3Cpath d='M8.39961 4.2002L5.39961 7.8002L3.59961 6.0002' stroke='white' stroke-width='1.2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    }

  }

  &.yellow {
    color: $colorY60;
    background: $colorY05;

    &::before {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2ZM7.99999 3.20005C10.651 3.20005 12.8 5.34908 12.8 8.00005C12.8 10.651 10.651 12.8 7.99999 12.8C5.34902 12.8 3.19999 10.651 3.19999 8.00005C3.19999 5.34908 5.34902 3.20005 7.99999 3.20005ZM8.59595 4.69006C8.56129 4.39166 8.30769 4.16003 7.99999 4.16003C7.66862 4.16003 7.39999 4.42866 7.39999 4.76003V8.00003L7.40519 8.0789C7.42243 8.20892 7.48196 8.33053 7.57572 8.4243L9.19572 10.0443L9.25225 10.0942C9.48762 10.2772 9.82796 10.2606 10.0443 10.0443L10.0942 9.98777C10.2772 9.7524 10.2605 9.41206 10.0443 9.19577L8.59999 7.75103V4.76003L8.59595 4.69006Z' fill='%23A38712'/%3E%3C/svg%3E");
    }

  }

  &.red {
    color: $colorE60;
    background: $colorE05;

    &::before {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 18 18' xmlns:v='https://vecta.io/nano'%3E%3Ccircle cx='9' cy='9' fill='%23ff3939' r='7.5'/%3E%3Cpath d='M9.745 5.913A.75.75 0 0 0 8.25 6v3l.005.087A.75.75 0 0 0 9.75 9V6l-.005-.087zM9 12.75a.75.75 0 1 0 0-1.5.75.75 0 1 0 0 1.5z' fill='%23fff' fill-rule='evenodd'/%3E%3C/svg%3E");
    }

  }

  &.gray {
    color: var(--Neutral---Background-N60, #6B6B6B);
    background: var(--Neutral---Background-N10, #F5F5F5);

    &::before {
      width: 15px;
      height: 16px;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='15' height='16' fill='none' xmlns:v='https://vecta.io/nano'%3E%3Cpath fill-rule='evenodd' d='M9.878 4.528c.546-.452 1.296.298.844.844l-.048.052L8.099 8l2.575 2.576c.549.549-.233 1.363-.796.896l-.052-.047L7.25 8.849l-2.576 2.575a.6.6 0 0 1-.792.05l-.057-.05a.6.6 0 0 1-.05-.792l.05-.057L6.401 8 3.826 5.424a.6.6 0 0 1-.05-.792l.05-.057a.6.6 0 0 1 .792-.05l.057.05L7.25 7.151l2.576-2.575.052-.048z' fill='%236b6b6b'/%3E%3C/svg%3E");
    }

    &::after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='17' height='16' fill='none' xmlns:v='https://vecta.io/nano'%3E%3Cpath fill-rule='evenodd' d='M12.193 7.334c.26-.26.26-.682 0-.943-.24-.24-.619-.259-.88-.055l-.063.055L8.25 9.39 5.23 6.392c-.24-.24-.618-.259-.88-.055l-.063.055c-.24.24-.259.618-.055.88l.055.063 3.491 3.47c.24.24.618.259.88.056l.063-.056 3.472-3.47z' fill='%236b6b6b'/%3E%3C/svg%3E");
    }
  }
}
</style>
